// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__17ldk","title":"Header_title__1dfKI","side":"Header_side__3pA70"};